export type ChatImageTiltRotation = -90 | 0 | 90;

export type ChatImageSize = {
  width: number;
  height: number;
};

type GravityVector = {
  x: number;
  y: number;
  z: number;
};

const ENTER_AXIS_GRAVITY = 6.5;
const AXIS_DOMINANCE_MARGIN = 1.5;

export function getRotatedChatImageSize(
  rotation: ChatImageTiltRotation,
  imageSize: ChatImageSize | undefined,
): ChatImageSize | undefined {
  if (!imageSize || rotation === 0) {
    return imageSize;
  }

  return {
    width: imageSize.height,
    height: imageSize.width,
  };
}

export function getNextChatImageTiltRotation(
  currentRotation: ChatImageTiltRotation,
  gravity: GravityVector,
): ChatImageTiltRotation {
  'worklet';

  const horizontalGravity = Math.abs(gravity.x);
  const verticalGravity = Math.abs(gravity.y);

  if (
    horizontalGravity >= ENTER_AXIS_GRAVITY &&
    horizontalGravity >= verticalGravity + AXIS_DOMINANCE_MARGIN
  ) {
    return gravity.x > 0 ? -90 : 90;
  }

  if (
    verticalGravity >= ENTER_AXIS_GRAVITY &&
    verticalGravity >= horizontalGravity + AXIS_DOMINANCE_MARGIN
  ) {
    return 0;
  }

  return currentRotation;
}
